import { createSlice } from "@reduxjs/toolkit";

interface initialStateProps {
    homePageSearchClicked: boolean;
    homePageSearchValue: string;
    afterSignInRoute:string;
    userRole: "landlord"|"booker"|null
}

const initialState = {
    homePageSearchClicked: false,
    homePageSearchValue: "",
    afterSignInRoute: "/dashboard",
    userRole: null
}

export const utilSLice = createSlice({
  name: "utils",
  initialState,
  reducers: {
    SethomePageSearchClicked(state, action) {
      state.homePageSearchClicked = action.payload;
    },
    setAfterSignInRoute(state, action) {
      state.afterSignInRoute = action.payload;
    },
    setUserRole(state, action) {
      state.userRole = action.payload;
    }
  }
})
export const {
    SethomePageSearchClicked,
    setAfterSignInRoute,
    setUserRole
} = utilSLice.actions